// extracted by mini-css-extract-plugin
module.exports = {"headerRoot":"header_headerRoot__2jtBi","navList":"header_navList__2P80q","logo":"header_logo__13VgX"};